import { Button, Typography } from '@material-ui/core';

export default function ButtonEmployeeEdit({
  row,
  setOpen,
  setSelected,
  isRTL,
}: any) {
  return (
    <Button
      variant="outlined"
      onClick={() => {
        setOpen(true);
        setSelected(row);
      }}
      style={{ width: 70 }}
    >
      <Typography style={{ fontSize: 12, fontWeight: 'bold' }}>
        {isRTL ? 'فتح' : 'Open'}
      </Typography>
    </Button>
  );
}
